module.exports = __webpack_public_path__ + "bd34935d8d1b002a2de012042b31eb4a.svg";